const TURN_HASH_PREFIX = 'kz-turn-';
const MESSAGE_HASH_PREFIX = 'kz-message-';

export const parseKaizenAnchorHash = (hash) => {
  if (typeof hash !== 'string' || !hash.startsWith('#')) {
    return null;
  }

  const anchorId = hash.slice(1);
  if (!anchorId) {
    return null;
  }

  if (anchorId.startsWith(TURN_HASH_PREFIX) && anchorId.length > TURN_HASH_PREFIX.length) {
    return { anchorId, kind: 'turn' };
  }

  if (anchorId.startsWith(MESSAGE_HASH_PREFIX) && anchorId.length > MESSAGE_HASH_PREFIX.length) {
    return { anchorId, kind: 'message' };
  }

  return null;
};
